import ReferencesFilters from './references-filters';

export default class ReferencesFiltersDesktop extends ReferencesFilters {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/references-filters/references-filters.desktop.js